const getToolSpecification = metadata => tool => {
  return metadata.tools[tool];
};

const toolApiCreater = metadata => ({
  getToolSpecification: getToolSpecification(metadata),
});

export default toolApiCreater;



// WEBPACK FOOTER //
// ./src/modules/tool.js